import { render, staticRenderFns } from "./newsTypeAdd.vue?vue&type=template&id=831b30aa"
import script from "./newsTypeAdd.vue?vue&type=script&lang=js"
export * from "./newsTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('831b30aa')) {
      api.createRecord('831b30aa', component.options)
    } else {
      api.reload('831b30aa', component.options)
    }
    module.hot.accept("./newsTypeAdd.vue?vue&type=template&id=831b30aa", function () {
      api.rerender('831b30aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/newsTypeSet/newsTypeAdd.vue"
export default component.exports